export default __webpack_public_path__ + "static/bendito@2x-4ae475494a8abc0f94ae0f5be16cb502.png";